// extracted by mini-css-extract-plugin
module.exports = {"b1jmz9ow":"b1jmz9ow"};